import { useEffect, useRef } from "react";
// import { Blog, BlogCategory, blogs } from "./blog-data";
import NoDataImage from "../../assets/images/nodata.png";
// import ResourceFilters from "../../components/library/filters/resource-filters";
import Layout from "../../components/layout/layout";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ResourceCategory } from "../../utils/dataHelpers/resources-data";
// import { BlogCard } from "../../components/library/cards/blog-card";

// function filterBlog(
//   list: Blog[],
//   searchTerm: string,
//   activeCategory: BlogCategory,
// ): Blog[] {
//   const term = searchTerm.trim().toLowerCase();

//   return list.filter((item) => {
//     const matchesCategory =
//       activeCategory === "All Blogs" || item.category === activeCategory;

//     const matchesSearch =
//       !term ||
//       item.title.toLowerCase().includes(term) ||
//       item.description.toLowerCase().includes(term);

//     return matchesCategory && matchesSearch;
//   });
// }

// const mapBlogCategoryToResourceCategory = (
//   category: BlogCategory,
// ): ResourceCategory => {
//   switch (category) {
//     case "All Blogs":
//       return "All Resources";
//     case "White Paper":
//       return "White Paper";
//     case "Case Study":
//       return "Case Study";
//     case "Guide":
//       return "Guide";
//     case "Report":
//       return "Report";
//     default:
//       return "All Resources";
//   }
// };

// const mapResourceCategoryToBlogCategory = (
//   category: ResourceCategory,
// ): BlogCategory => {
//   switch (category) {
//     case "All Resources":
//       return "All Blogs";
//     case "White Paper":
//       return "White Paper";
//     case "Case Study":
//       return "Case Study";
//     case "Guide":
//       return "Guide";
//     case "Report":
//       return "Report";
//     default:
//       return "All Blogs";
//   }
// };

const BlogPage = () => {
  // const [searchTerm] = useState<string>("");
  // const [activeCategory] = useState<BlogCategory>("All Blogs");

  const pageRef = useRef<HTMLDivElement | null>(null);

  // const filteredBlog = useMemo(
  //   () => filterBlog(blogs, searchTerm, activeCategory),
  //   [searchTerm, activeCategory],
  // );

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      const heroTl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 0.7 },
      });

      heroTl
        .from(".resource-hero-title", {
          y: 24,
          opacity: 0,
        })
        .from(
          ".resource-hero-subtitle",
          {
            y: 28,
            opacity: 0,
          },
          "-=0.4",
        );

      gsap.from(".resource-filters-section", {
        y: 30,
        opacity: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".resource-filters-section",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      gsap.from(".resource-grid", {
        y: 40,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".resource-grid",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      gsap.from(".resource-card", {
        y: 30,
        opacity: 0,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: ".resource-grid",
          start: "top 75%",
          toggleActions: "play none none reverse",
        },
      });
    }, pageRef);

    return () => ctx.revert();
  }, []);

  return (
    <Layout
      footerData={{
        showInput: true,
        headerText: "Stay Updated",
        bodyText:
          "Get the latest insights on customer engagement, retention strategies, and industry trends delivered to your inbox every week",
      }}
    >
      <div ref={pageRef} className="space-y-8 pb-16">
        <section
          className="
            relative bg-[#2C73DB]
            rounded-bl-[80px] rounded-br-[80px]
            md:rounded-bl-[160px] md:rounded-br-[160px]
            lg:rounded-bl-[200px] lg:rounded-br-[200px]
            text-white pt-28 flex items-end justify-center
          "
        >
          <div className="max-w-5xl relative px-4 sm:px-6">
            <div className="loyalty-hero-heading text-center mb-[10%]">
              <div className="inline-flex items-center bg-[#ffffff33] text-xs font-[300] py-2 px-3 rounded-full mb-3 border border-[#fff] shadow-[0_0_18px_rgba(59,130,246,0.25)]">
                Insights & Resources
              </div>

              <h1 className="text-3xl lg:text-4xl font-medium leading-tight mb-4 px-2">
                Bridgetune Blog
              </h1>
              <p className="text-sm md:text-base text-blue-100 max-w-2xl mx-auto leading-relaxed">
                Expert insights, industry trends, and best practices for
                customer engagement, retention, and loyalty in African markets
              </p>
            </div>
          </div>
        </section>

        <div className="space-y-4 rounded-[40px] md:rounded-[60px] text-[#000] bg-[#f0f6ff] p-12 flex flex-col items-center max-w-6xl mx-auto ">
          <h1 className="text-xl lg:text-3xl font-medium ">
            No Blog At The Moment
          </h1>
          <p className="text-sm text-[#8e8e8e]">Blog Post Coming Soon</p>
          <img src={NoDataImage} alt="No Data" className="mx-auto mt-4" />
          <h3>Check Back Soon For More Blog Posts</h3>
        </div>

        {/* Filters & search */}
        {/* <div className="resource-filters-section relative mx-auto max-w-4xl px-6 mb-24">
          <ResourceFilters
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            activeCategory={mapBlogCategoryToResourceCategory(activeCategory)}
            onCategoryChange={(category: ResourceCategory) =>
              setActiveCategory(mapResourceCategoryToBlogCategory(category))
            }
          />
        </div> */}

        {/* Cards grid */}
        {/* <div className="relative mx-auto max-w-6xl bg-blue-50 py-12 px-6 md:p-12 rounded-[60px]">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {filteredBlog.map((resource) => (
              <div key={resource.id} className="resource-card">
                <BlogCard blog={resource} />
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </Layout>
  );
};

export default BlogPage;
